// import React, { useEffect } from "react";

// const AnalyticsComponent = () => {
//   const VIEW_ID = "228938676";

//   useEffect(() => {
//     const queryReports = async () => {
//       try {
//         const response = await (window as any).gapi.client.request({
//           path: "/v4/reports:batchGet",
//           root: "https://analyticsreporting.googleapis.com/",
//           method: "POST",
//           body: {
//             reportRequests: [
//               {
//                 viewId: VIEW_ID,
//                 dateRanges: [
//                   {
//                     startDate: "7daysAgo",
//                     endDate: "today",
//                   },
//                 ],
//                 metrics: [
//                   {
//                     expression: "ga:sessions",
//                   },
//                 ],
//               },
//             ],
//           },
//         });

//         displayResults(response);
//       } catch (error) {
//         console.error("Error querying reports:", error);
//       }
//     };

//     const displayResults = (response: any) => {
//       const formattedJson = JSON.stringify(response.result, null, 2);
//       const queryOutput = document.getElementById(
//         "query-output"
//       ) as HTMLTextAreaElement;

//       if (queryOutput) {
//         queryOutput.value = formattedJson;
//       }
//     };

//     const handleSignInSuccess = () => {
//       console.log("succ");
//       queryReports();
//     };

//     const loadGoogleAPI = () => {
//       (window as any).gapi?.load("client:platform", initClient);
//     };

//     const initClient = () => {
//       (window as any).gapi.client
//         .init({
//           apiKey: "AIzaSyAAepAxxJUo6_vUuxgkADp0jt-coE4vL1c",
//           clientId:
//             "494843491448-k8obmrcf0ls43ru53huvnlpabrkbj8mc.apps.googleusercontent.com",
//           scope: "https://www.googleapis.com/auth/analytics.readonly",
//         })
//         .then(() => {
//           (window as any).gapi.auth2
//             .getAuthInstance()
//             .isSignedIn.listen(handleSignInSuccess);
//           handleSignInSuccess();
//         });
//     };

//     loadGoogleAPI();
//   }, [VIEW_ID]);

//   return (
//     <div>
//       <h1>Hello Analytics Reporting API V4</h1>
//       {/* The Sign-in button. This will run `queryReports()` on success. */}
//       <div className="g-signin2"></div>
//       {/* The API response will be printed here. */}
//       <textarea cols={80} rows={20} id="query-output"></textarea>
//     </div>
//   );
// };

// export default AnalyticsComponent;

// import axios from "axios";
// import React, { useEffect } from "react";

// const AnalyticsComponent = () => {
//   const VIEW_ID = "228938676";
//   function getGaClientId() {
//     const gaCookie = document.cookie
//       .split(";")
//       .find((cookie) => cookie.trim().startsWith("_ga="));

//     if (gaCookie) {
//       const clientIdMatch = gaCookie.match(/(\d+\.\d+)$/);
//       if (clientIdMatch) {
//         return clientIdMatch[0];
//       }
//     }

//     return null;
//   }
//   const clientId = getGaClientId();
//   console.log(clientId);
//   axios
//     .post(
//       "https://www.googleapis.com/analytics/v3/data/ga",
//       {
//         reportRequests: [
//           {
//             viewId: VIEW_ID,
//             dateRanges: [
//               {
//                 startDate: "7daysAgo",
//                 endDate: "today",
//               },
//             ],
//             metrics: [
//               {
//                 expression: "ga:sessions",
//               },
//             ],
//             dimensions: [
//               {
//                 name: "ga:browser",
//               },
//             ],
//             dimensionFilterClauses: [
//               {
//                 filters: [
//                   {
//                     dimensionName: "ga:clientId",
//                     operator: "EXACT",
//                     expressions: [clientId],
//                   },
//                 ],
//               },
//             ],
//           },
//         ],
//       },
//       {
//         headers: {
//           Authorization: "Bearer YOUR_ACCESS_TOKEN",
//         },
//       }
//     )
//     .then((response) => {
//       console.log(response.data);
//     })
//     .catch((error) => {
//       console.error(error);
//     });

//   return (
//     <div>
//       <h1>Hello Analytics Reporting API V4</h1>
//       <p>
//         {/* The Sign-in button. This will run `queryReports()` on success. */}
//         <button id="signin-btn" className="g-signin2">
//           Sign In with Google
//         </button>
//       </p>
//       {/* The API response will be printed here. */}
//       <textarea cols={80} rows={20} id="query-output"></textarea>
//     </div>
//   );
// };

// export default AnalyticsComponent;

import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import axios from 'axios';

const AnalyticsComponent = () => {
  const handleAuthorization = async (code) => {
    const apiUrl = 'https://oauth2.googleapis.com/token'; // Replace with your server URL
    const clientCredentials = {
      // code,
      client_id: '494843491448-k8obmrcf0ls43ru53huvnlpabrkbj8mc.apps.googleusercontent.com',
      client_secret: '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',
      redirect_uri: 'http://clientportal.mindandmom.com/analysis',
    };
    try {
      const response = await axios.post(apiUrl, clientCredentials);
      // console.log(response.data.accessToken);
      // setAccessToken(response.data.accessToken);
    } catch (error) {
      console.error(error.message);
    }
  };
  handleAuthorization()
  return (
    <div>
      <h1>Google Analytics Report</h1>
      {/* Your component content goes here */}
    </div>
  );
};

export default AnalyticsComponent;

// import React, { useEffect } from 'react';
// import ReactGA from 'react-ga';
// import axios from 'axios';

// const AnalyticsComponent = () => {
//   useEffect(() => {
//     // Initialize Google Analytics
//     ReactGA.initialize('YOUR_GOOGLE_ANALYTICS_TRACKING_CODE');
//     ReactGA.pageview(window.location.pathname + window.location.search);

//     // Make API request to get the Google Analytics report
//     const fetchData = async () => {
//       const response = await axios.post(
//         'https://analyticsreporting.googleapis.com/v4/reports:batchGet',
//         {
//           reportRequests: [
//             {
//               viewId: '228938676',
//               dateRanges: [
//                 {
//                   startDate: '7daysAgo',
//                   endDate: 'today',
//                 },
//               ],
//               metrics: [
//                 {
//                   expression: 'ga:sessions',
//                 },
//               ],
//               dimensions: [
//                 {
//                   name: 'ga:browser',
//                 },
//               ],
//             },
//           ],
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${'YOUR_ACCESS_TOKEN'}`,
//           },
//         }
//       );

//       console.log(response.data);
//     };

//     fetchData();
//   }, []); // Empty dependency array to run the effect only once when the component mounts

//   return (
//     <div>
//       <h1>Google Analytics Report</h1>
//       {/* Display the report data here */}
//     </div>
//   );
// };

// export default AnalyticsComponent;
